import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../controls/LanguageSwitcher/LanguageSwitcher';
import { AnswerView } from '../../services/service-evaluation-answer';
import styles from './page-evaluation-answer.module.scss';

type Props = {
  org: AnswerView['org'] | null;
  respondent?: string | null;
  children: ReactNode;
};

const AnswerShell: FC<Props> = ({ org, respondent, children }) => {
  const [t] = useTranslation('evaluations');
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div className={styles.brand}>
          {org && (
            <>
              {org.logoURL ? (
                <img className={styles.logo} src={org.logoURL} alt={org.name} />
              ) : (
                <span className={styles.orgName}>{org.name}</span>
              )}
              <span className={styles.brandDivider} aria-hidden="true">
                /
              </span>
            </>
          )}
          <span className={styles.brandProduct}>{t('answer.kicker', 'Utvärdering')}</span>
        </div>
        <div className={styles.headerEnd}>
          {respondent && (
            <span className={styles.respondent}>
              {t('answer.respondingAs', 'Svarar som')} <strong>{respondent}</strong>
            </span>
          )}
          <LanguageSwitcher className={styles.languageSwitcher} />
        </div>
      </header>
      <main className={styles.main}>{children}</main>
    </div>
  );
};

export default AnswerShell;
